import axios, { CancelTokenSource } from "axios";

import { API_URLS } from "src/utils/API_URLS";
import {
  ApiResponse,
  GlobalTaskSearchResult,
  ProjectSearchResult,
} from "src/types";

const SearchResultsService = {
  getGlobalTasks: async (
    wsWorkspaceUuid: string,
    queryData?: string[],
    signal?: CancelTokenSource,
  ): Promise<GlobalTaskSearchResult[]> => {
    const requestQuery =
      queryData && queryData.length > 0 ? queryData.join(",") : "";

    const url = API_URLS.getSearchResultsUrl;
    try {
      const response = await axios.post<
        ApiResponse<{ globalTasks: GlobalTaskSearchResult[] }>
      >(
        url,
        {
          query: requestQuery,
          wsWorkspaceUuid,
          type: "globalTasks",
        },
        { cancelToken: signal?.token },
      );
      return response.data.content.globalTasks;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  getProjects: async (
    wsWorkspaceUuid: string,
    queryData?: string[],
    signal?: CancelTokenSource,
  ): Promise<ProjectSearchResult[]> => {
    const requestQuery =
      queryData && queryData.length > 0 ? queryData.join(",") : "";

    const url = API_URLS.getSearchResultsUrl;
    try {
      const response = await axios.post<
        ApiResponse<{ projects: ProjectSearchResult[] }>
      >(
        url,
        {
          query: requestQuery,
          wsWorkspaceUuid,
          type: "projects",
        },
        { cancelToken: signal?.token },
      );
      return response.data.content.projects;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

export default SearchResultsService;
